import type { ExpressionErrorAlertProps } from "./expression-error-alert.type";

import { Trans } from "react-i18next";

import { HelpCenterLink } from "@/modules/help-center";
import { Alert } from "@/ui/alert";

import { getExpressionErrorInfos } from "../expression.helper";

export const ExpressionErrorAlert = ({
  error: errorInput,
}: ExpressionErrorAlertProps) => {
  const error = getExpressionErrorInfos(errorInput);

  if (!error) return null;

  return (
    <Alert
      display
      closable={false}
      title={
        <Trans
          i18nKey={`expression:error.${error.code}`}
          components={{ HelpLink: <HelpCenterLink /> }}
        />
      }
    />
  );
};
